import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { reportClientEvent } from './api/client'

// ── Global crash reporters ──────────────────────────────────────────────
// Anything that slips past React's error boundaries lands here. We also
// catch unhandled Promise rejections (async/await failures not awaited).
// Debounced so a runaway error loop doesn't flood the backend.
let _lastReportTs = 0;
const _MIN_INTERVAL_MS = 2000;
function _maybeReport(payload: Record<string, unknown>) {
  const now = Date.now();
  if (now - _lastReportTs < _MIN_INTERVAL_MS) return;
  _lastReportTs = now;
  reportClientEvent('frontend_error', payload);
}

window.addEventListener('error', (e) => {
  _maybeReport({
    message: String(e.message ?? ''),
    filename: String(e.filename ?? ''),
    lineno: e.lineno ?? 0,
    colno: e.colno ?? 0,
    stack: e.error?.stack ? String(e.error.stack).slice(0, 800) : '',
  });
});

window.addEventListener('unhandledrejection', (e) => {
  const reason = e.reason;
  _maybeReport({
    kind: 'unhandledrejection',
    message: reason instanceof Error ? reason.message : String(reason ?? ''),
    stack: reason instanceof Error && reason.stack ? reason.stack.slice(0, 800) : '',
  });
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
